import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { faAdd, faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataTableDynamic from '../../../../component/Table/DataTableDynamic';
import Tab from '../../../../component/Tabs/Tab';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';

const Expenses = () => {
  const navigate = useNavigate();
  const [keys, setKeys] = useState([]);
  const [columns, setColumns] = useState([]);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [data, setData] = useState([]);
  const [isNextPage, setIsNextPage] = useState(true);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const [activeType, setActiveType] = useState("expenses");
  const tabHeader = [
    {
      "key": "expenses",
      "label": "Biaya",
    },
    {
      "key": "need_approval",
      "label": "Membutuhkan Persetujuan"
    }
  ];

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_SALES = "api/erpppsu/expenses";

  // Fetch data from the API
  const fetchData = async (URL, config) => {
    try {
      const response = await axios.get(URL, config);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_SALES}?type=${activeType}`, {
      params: {
        offset: pageIndex,
        limit: pageSize
      }
    }).then((data) => {
      setData(data.data);
    });
  }, [activeType]);

  useEffect(() => {
    setKeys(data.length > 0 ? Object.keys(data[0]) : []);
  }, [data]);

  useEffect(() => {
    setColumns(keys.map(key => ({
      Header: key.charAt(0).toUpperCase() + key.slice(1),
      accessor: key
    })));
  }, [keys]);

  const handleTabClick = (tab) => {
    setActiveType(tab);
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleDetail = (rowData) => {
    navigate(`/activity-erpppsu/expenses/detail/${rowData.id.value}`);
  };

  const options = [
    { value: 'new-expenses', label: 'Biaya Baru' }
  ];

  const actions = [{
    child: <button className='text-white text-xs rounded focus:ring bg-blue-500 hover:bg-blue-700 p-2 mx-1'>
      <FontAwesomeIcon icon={faInfo} color="white" />nfo
    </button>,
    callback: (rowData) => handleDetail(rowData)
  }];

  return (
    <div>
      <div className='flex items-center justify-between'>
        <h1>Biaya</h1>

        <div className='flex items-center'>
          <ButtonOptionGroup
            label={"Tindakan"}
            options={options}
            onChange={(value) => {
              navigate(`/activity-erpppsu/expenses/new`);
            }}
          />
        </div>
      </div>

      <div className="tabs">
        {tabHeader.map((tab) => (
          <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
            handleTabClick(tab.key)
          }} />
        ))}
      </div>

      {loading ? (
        <center><h1>Loading...</h1></center>
      ) : (
        <DataTablePageDynamic
          data={data}
          nextPage={isNextPage}
          columns={columns}
          elementClass="p-1"
          actions={actions}
          onDataChange={(pageIndex, pageSize, sortBy) => {
            fetchData(`${BASE_URL}${PATH_SALES}?type=${activeType}`, {
              params: {
                offset: pageIndex,
                limit: pageSize
              }
            }).then((data) => {
              setIsNextPage(data.more>0);
              setData(data.data);
            });
          }} />
      )}
    </div>
  )
}

export default Expenses;
